/**
 * @generated SignedSource<<1c0fee817121893fe809584e5c6d041a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderAuthenticatedUser_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableUserAccounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoRedirectSsoUrl",
      "storageKey": null
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "d05aecfe8bb17ea336b4cc243436a1cd";

module.exports = node;
